import { useMutation } from 'react-apollo';

import {
  accountLoginByEmail as accountLoginByEmailMutation,
  emailAuthenticationRequest as emailAuthenticationRequestMutation,
} from '../../../graphql/mutations/account';
import { EMAIL_AUTH_INTENT } from '../../../constants/auth';
import { gtm } from '../../../util/analytics';

const useEmailPinAuth = () => {
  const [emailAuthenticationRequest] = useMutation(
    emailAuthenticationRequestMutation,
  );

  const onEmailAuthenticationRequest = async ({ emailAddress }) => {
    const result = await emailAuthenticationRequest({
      variables: {
        input: {
          email_address: emailAddress,
          intent: EMAIL_AUTH_INTENT.LOGIN,
          use_pin_code: true,
        },
      },
    });

    return result;
  };

  const [accountLoginByEmail] = useMutation(accountLoginByEmailMutation);

  const onLoginByEmail = async ({ emailAddress, code }) => {
    const result = await accountLoginByEmail({
      variables: {
        input: {
          email_address: emailAddress,
          email_authentication_code: code,
          set_cookie: true,
        },
      },
    });

    const {
      data: { accountLoginByEmail: accountLoginByEmailRes } = {},
    } = result;

    if (accountLoginByEmailRes && !accountLoginByEmailRes?.existing_account) {
      gtm.trackCustomEvent({
        event: 'Consumer_Account_Created',
        user_id: accountLoginByEmailRes?.account?.id,
      });
    }

    return result;
  };

  return {
    onEmailAuthenticationRequest,
    onLoginByEmail,
  };
};

export default useEmailPinAuth;
